import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import Reveal from "./Reveal";

const FAQS = [
    {
        q: "¿Necesito experiencia previa en ecommerce?",
        a: "No. El programa empieza desde cero. El módulo 1 cubre mentalidad y protocolo antes de tocar cualquier plataforma.",
    },
    {
        q: "¿Esto funciona en República Dominicana?",
        a: "Sí. Está especializado en RD y LATAM. El modelo COD es la mayor ventaja — el cliente paga cuando recibe, sin tarjeta de crédito.",
    },
    {
        q: "¿Cuánto dinero necesito para empezar?",
        a: "Con $300 USD puedes comenzar. El módulo 1 tiene una calculadora de presupuesto y una ruta clara según tu capital.",
    },
    {
        q: "¿Cuánto tiempo necesito dedicarle?",
        a: "Con 2-3 horas al día es suficiente. El contenido es grabado y lo ves a tu ritmo. Las llamadas en vivo son los lunes y jueves.",
    },
    {
        q: "¿Qué diferencia a esto de un curso normal?",
        a: "Un curso te vende videos y te deja solo. BIZecomacademy tiene llamadas semanales en vivo, comunidad activa y seguimiento hasta que generes tu primera venta.",
    },
    {
        q: "¿La consultoría tiene algún costo?",
        a: "No. La consultoría es 100% gratuita. Son 20 minutos para evaluar si el programa es el fit correcto para ti. Si no lo es, te lo decimos también.",
    },
];

export default function Faq() {
    const [open, setOpen] = useState(null);

    return (
        <section className="relative overflow-hidden px-5 py-20 sm:py-28" data-testid="faq-section">
            <span className="chapter-num absolute -top-4 left-2 text-[9rem] sm:text-[13rem]" aria-hidden="true">
                02
            </span>
            <div className="relative mx-auto max-w-3xl">
                <Reveal>
                    <div className="mb-4 flex items-center gap-2">
                        <span className="h-1.5 w-1.5 rounded-full bg-[#ff5c00]" />
                        <span className="text-xs font-medium uppercase tracking-[0.2em] text-[#888]">Preguntas frecuentes</span>
                    </div>
                    <h2 className="font-display text-3xl font-extrabold leading-[1.08] sm:text-5xl">
                        Antes de que <em className="serif-accent text-grad">preguntes</em>
                    </h2>
                </Reveal>

                <Reveal delay={120} className="mt-10">
                    <div className="divide-y divide-[#1e1e1e] rounded-2xl border border-[#222] bg-[#111111]">
                        {FAQS.map((item, i) => {
                            const isOpen = open === i;
                            return (
                                <div key={item.q}>
                                    <button
                                        onClick={() => setOpen(isOpen ? null : i)}
                                        className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left sm:px-7"
                                        aria-expanded={isOpen}
                                        data-testid={`faq-item-${i}`}
                                    >
                                        <span className={`font-display text-sm font-bold sm:text-base ${isOpen ? "text-[#ff7a30]" : "text-[#e5e5e5]"}`}>
                                            {item.q}
                                        </span>
                                        <Plus
                                            className={`h-5 w-5 shrink-0 transition-transform duration-300 ${
                                                isOpen ? "rotate-45 text-[#ff5c00]" : "text-[#555]"
                                            }`}
                                        />
                                    </button>
                                    <AnimatePresence initial={false}>
                                        {isOpen && (
                                            <motion.div
                                                initial={{ height: 0, opacity: 0 }}
                                                animate={{ height: "auto", opacity: 1 }}
                                                exit={{ height: 0, opacity: 0 }}
                                                transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
                                                className="overflow-hidden"
                                            >
                                                <p className="px-5 pb-6 text-sm leading-relaxed text-[#999] sm:px-7" data-testid={`faq-answer-${i}`}>
                                                    {item.a}
                                                </p>
                                            </motion.div>
                                        )}
                                    </AnimatePresence>
                                </div>
                            );
                        })}
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
